export const ToastCollapseDuration = 300

export const ToastAutoCloseTimeout = 3000

export const ToastDraggablePercentage = 0.6
